export default __webpack_public_path__ + "static/media/diamond-carat-3@3x.b0b11609.jpg";